import React from "react";
import {injectIntl} from "react-intl";
import {ACCESSCODE, ACCESSCODEPURCH, ACCESSLOGIN, ACCESSLOGINPURCH} from "./utils/panel-helper";
import MSStreamRegistration from "../widgets/ms-stream-registration.jsx";
import MSStreamLogin from "../widgets/ms-stream-login.jsx";

class MSPanels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPanel: false
    }
  }

  render() {
    let component = null;
    switch (this.props.streamType) {
      case ACCESSCODE:
      case ACCESSCODEPURCH:
        component = (
          <MSStreamRegistration
            streamName={this.props.streaName}
            goLive={this.props.goLive}
            isEcommerce={this.props.ecomm}
            restMS={this.props.restMS}
            wcdata={this.props.wcdata}
            loadPlayer={this.props.loadPlayer}
            hidePlayer={this.props.hidePlayer}
            externally_managed={this.props.externally_managed}
            external_access_code_page={this.props.external_access_code_page}
          />
        );
        break;
      case ACCESSLOGIN:
      case ACCESSLOGINPURCH:
        component = (
          <MSStreamLogin
            streamName={this.props.streaName}
            goLive={this.props.goLive}
            isEcommerce={this.props.ecomm}
            restMS={this.props.restMS}
            wcdata={this.props.wcdata}
            loadPlayer={this.props.loadPlayer}
            hidePlayer={this.props.hidePlayer}
            externally_managed={this.props.externally_managed}
            external_access_code_page={this.props.external_access_code_page}
          />
        );
        break;
    }
    return (
      component
    )
  }
}
export default injectIntl(MSPanels);
